import React from 'react';
import { GeckoModalService } from 'ui';
import DeleteAgentModal from './index.jsx';

export default (agent_id) => {
  return new GeckoModalService().open(() => (
    <DeleteAgentModal agent_id={agent_id} />
  ));
};
